// Fills in the estimated delivery window under the buy buttons. The server renders a
// fallback line, which stays when this script fails or when the visitor's country has
// no transit times set.
(() => {
  if (window.RinslyDelivery) return;

  const dayFormat = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' });

  // Counts Monday to Friday forward from the order day; the order day itself never counts.
  const addBusinessDays = (from, days) => {
    const date = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    let added = 0;
    while (added < days) {
      date.setDate(date.getDate() + 1);
      const weekday = date.getDay();
      if (weekday !== 0 && weekday !== 6) added += 1;
    }
    return date;
  };

  // "Oct 23–31" within one month, "Oct 23 – Nov 5" across months.
  const formatRange = (start, end) => {
    if (start.getTime() === end.getTime()) return dayFormat.format(start);
    if (start.getFullYear() === end.getFullYear() && start.getMonth() === end.getMonth()) {
      return `${dayFormat.format(start)}–${end.getDate()}`;
    }
    return `${dayFormat.format(start)} – ${dayFormat.format(end)}`;
  };

  const estimate = (from, minDays, maxDays) =>
    formatRange(addBusinessDays(from, minDays), addBusinessDays(from, Math.max(minDays, maxDays)));

  // Blank or invalid settings come through as empty strings and return null.
  const toDays = (value) => {
    if (value === undefined || value.trim() === '') return null;
    const days = Number(value);
    return Number.isInteger(days) && days >= 0 ? days : null;
  };

  const init = (scope) => {
    scope.querySelectorAll('[data-rn-delivery]').forEach((row) => {
      const data = row.dataset;
      const isUS = data.country === 'US';
      const days = [data.processingMin, data.processingMax, isUS ? data.usMin : data.intlMin, isUS ? data.usMax : data.intlMax].map(toDays);
      const text = row.querySelector('[data-rn-delivery-text]');
      if (days.includes(null) || !data.template || !text) return;

      const [processingMin, processingMax, transitMin, transitMax] = days;
      text.textContent = data.template.replace('[range]', estimate(new Date(), processingMin + transitMin, processingMax + transitMax));
    });
  };

  window.RinslyDelivery = { estimate };

  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
